import React, { memo } from 'react';
import { makeStyles } from '@mui/styles';

import palette from '../../../components/styles/palette';
import { View } from '../../../components/Base';
import CenterMap from '../../../components/icons/CenterMap';

const useStyles = makeStyles(({ typography }) => ({
  container: {
    position: 'absolute',
    top: typography.pxToRem(-42),
    right: typography.pxToRem(20),
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: typography.pxToRem(5),
    gap: typography.pxToRem(8),
    width: typography.pxToRem(32),
    height: typography.pxToRem(32),
    background: palette.typography.white.solid,
    border: '1px solid rgba(0, 0, 0, 0.67)',
    boxShadow: '0px 3px 5px 1px rgb(0 0 0 / 20%)',
    borderRadius: typography.pxToRem(32),
    cursor: 'pointer',
    '&:hover': {
      boxShadow:
        '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)',
      backgroundColor: palette.lightGrey,
    },
  },
}));

const CenterMapButton = ({ onSelectCentreMap }) => {
  const style = useStyles();

  return (
    <View className={style.container} data-testid={'center-map'}>
      <CenterMap onClick={onSelectCentreMap} />
    </View>
  );
};

export default memo(CenterMapButton);
